import axios from "axios";
import { API } from "Developers/EstebanCaccin/constants";
import { ChangeEvent, MouseEvent, useContext, useState } from "react";
import { TLoginForm } from "./LoginForm";
import { AuthContext } from "../../../AuthContext/AuthContext";

type TUser = {
  email: string;
  password: string;
};
export const useLoginForm = ({ typeForm, closeModal }: TLoginForm) => {
  const { setToken } = useContext(AuthContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  const [handleSubmitState, setHandleSubmitState] = useState<boolean | string>(
    false
  );

  const [user, setUser] = useState<TUser>({
    email: "",
    password: ""
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const statusHandleSubmit = axios.post(
      `${API.url}${typeForm === "login" ? "signin" : "signup"}`,
      {
        email: user.email,
        password: user.password
      }
    );
    statusHandleSubmit.then(res => {
      const { data } = res;

      if (res.status === 201) {
        setHandleSubmitState(
          typeForm === "login"
            ? "Has Iniciado Sesión"
            : "Registrado exitosamente"
        );
        setSuccess(true);
        setToken(data.token);
        if (closeModal) {
          setTimeout(() => {
            closeModal();
          }, 1500);
        }
      }
    });
    statusHandleSubmit.catch(err => {
      setHandleSubmitState(err.response.data.msg);
    });
  };

  const spinner = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      if (user.email && user.password) {
        handleSubmit();
        setUser({
          email: "",
          password: ""
        });
      } else {
        setHandleSubmitState("Debes llenar todos los campos");
      }
      setLoading(false);
    }, 2000);
  };

  return {
    user,
    handleChange,
    handleSubmit,
    loading,
    spinner,
    handleSubmitState,
    success,
    setSuccess
  };
};
